/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M3 12h4l3 8l4 -16l3 8h4", "key": "svg-0" }]];
const IconActivity = createReactComponent("outline", "activity", "Activity", __iconNode);

export { __iconNode, IconActivity as default };
//# sourceMappingURL=IconActivity.mjs.map
